import { LabelFilterType } from '@/types/components/FilterType.js';

export const FilterCoverageType = 'Coverage Type';
export const FilterSICIndustry = 'SIC Industry';
export const FilterIndustry = 'Industry';
export const FilterWholesalerGroup = 'Wholesaler Group';
export const FilterCarrierGroup = 'Carrier Group';
export const FilterAttachment = 'Attachment';
export const FilterRetention = 'Retention';
export const FilterClientAttributes  ='Client Attributes';
export const FilterCACEntity = 'CAC Entity';
export const FilterAccountStates = 'Client State'
export const FilterMoreOptions = 'More Options';
export const FilterDepartments = 'Department';
export const FilterOwnershipType = 'Ownership Type';

export type FilterValueType = string | number;

export interface FilterField<FilterValueType> {
  category: string;
  description?: string;
  values: LabelFilterType<FilterValueType>[];
  range?: FilterRange;
  options?: FilterFieldOption[];
  prefix?: string;
}

export interface FilterFieldOption {
  category: string;
  label: string;
  type: 'toggle'
}

export interface FilterMoreOptions {
  daysUntilExpiration?: number;
  runoff?: boolean,
  noRunoff?: boolean,
  primary?: boolean,
  excess?: boolean,
}

export type FilterRange = [low: number, high: number];

export interface AppliedFilter {
  category: string;
  count: number;
}
